import { styled } from 'baseui'
import { FlexBetween, FlexColumn } from '@/shared/theme/styled-components'

export const Card = styled(FlexBetween, ({ $theme }) => ({
  margin: '0 0 1rem 0',
  background: $theme.colors.bg100,
  padding: '0.5rem',
  borderRadius: $theme.borders.radius400,
  boxShadow: $theme.lighting.shadow400,
  justifyContent: 'space-evenly',
}))

export const ChangeUserContainer = styled('div', () => ({
  maxWidth: '35%',
  display: 'flex',
  flex: '1 1 auto',
}))

export const InfoFieldsContainer = styled(FlexColumn, () => ({}))

export const StyledTitleWrapped = styled('h3', ({ $theme }) => ({
  flexGrow: 1,
  margin: 0,
  color: $theme.colors.primary,
  ...$theme.typography.HeadingXSmall,
  fontSize: '1.5rem',
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
}))

